<template>
  <section class="row privacy">
    <div class="col col-12 font--p1">
      <h1 class="font--d1 privacy__heading">Alberta Golf Privacy Policy</h1>
      <p class="privacy__content">
        Alberta Golf is committed to providing our members, volunteers and
        customers with exceptional service. As providing this service involves
        the collection, use and disclosure of some personal information about
        individuals, protecting their personal information is one of our highest
        priorities. We have always respected individuals’ privacy and
        safeguarded their personal information. We comply fully with applicable
        provincial and federal privacy legislation, which set out the ground
        rules for how organizations may collect, use and disclose personal
        information. We will inform individuals why and how we collect, use and
        disclose their personal information, obtain their consent where
        required, and only handle their personal information in a manner that a
        reasonable person would consider appropriate in the circumstances. This
        Privacy Policy outlines the principles and practices we will follow in
        protecting an individual’s personal information. Our privacy commitment
        includes ensuring the accuracy, confidentiality, and security of
        personal information and allowing individuals to request access to, and
        correction of, their personal information.
      </p>
      <h3 class="font--h2 privacy__heading">Scope of this Policy:</h3>
      <p>
        This Personal Information Protection Policy applies to Alberta Golf, its
        subsidiaries, and their employees. This policy also applies to any
        service providers collecting, using or disclosing personal information
        on behalf of Alberta Golf. <br /><br />
        To better understand our Privacy Policy, we wish to ensure that you
        understand key terms:
      </p>

      <p>
        <br />
        <span class="font--h3 privacy__subheading"
          >Personal Information –
        </span>
        means information about an identifiable individual, including name,
        address and other contact information, as well as membership details
        such as membership status, club affiliation and handicap. Personal
        information does not include business contact information, which would
        enable an individual to be contacted at a place of business and includes
        name, position name or title, business telephone number, business
        address, business email or business fax number.
      </p>

      <p>
        <br />
        <span class="font--h3 privacy__subheading">Privacy Officer – </span>
        means the individual at Alberta Golf designated with responsibility for
        ensuring that Alberta Golf complies with this policy and applicable
        legislation.
      </p>

      <h3 class="font--h2 privacy__heading">
        Policy 1 – Collecting Personal Information:
      </h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            Unless the purposes for collecting personal information are obvious
            and the individual voluntarily provides his or her personal
            information for those purposes, we will communicate the purposes for
            which personal information is being collected, either orally or in
            writing, before or at the time of collection.
          </li>
          <br />
          <li>
            We will only collect an individual’s information that is necessary
            to fulfill the following purposes:
          </li>
        </ul>
        <ul class="privacy__indent-list">
          <br />
          <li>
            To establish and maintain commercial and membership relationships
            and to provide ongoing services;
          </li>
          <li>To understand an individual’s needs and preferences;</li>
          <li>
            To recommend programs, merchandise and services to individuals;
          </li>
          <li>To inform you of Alberta Golf programs, services and benefits</li>
          <li>
            To develop, enhance, market and provide programs, merchandise and
            services;
          </li>
          <li>
            To facilitate and enhance your use of our websites and applications;
          </li>
          <li>To contact individuals for fundraising;</li>
          <li>To assist us in the collection of your account;</li>
          <li>To prevent fraud with respect to both you and our companies;</li>
          <li>To meet legal and regulatory requirements.</li>
        </ul>
      </div>

      <h3 class="font--h2 privacy__heading">
        Policy 2 – Using and Disclosing Personal Information:
      </h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            We will only use or disclose an individual’s personal information
            where necessary to fulfill the purposes identified above, or such
            other purposes as may be identified at the time of collection.
          </li>
          <br />
          <li>
            We will not use or disclose an individual’s personal information for
            any additional purpose unless we obtain consent to do so.
          </li>
          <br />
          <li>
            We will not sell member and customer lists or personal information
            to other parties unless we obtain your explicit consent to do so.
          </li>
          <br />
          <li>
            From time to time, we may share personal information with third
            parties who have been engaged to carry out certain functions on our
            behalf, such as to process the mailing of information to members, or
            to administer certain events. In each case, we will share only the
            personal information required by the third party to perform the
            function for which they have been retained. All service providers
            are required to keep personal information confidential, protect it
            using the same safeguards as employed by Alberta Golf, use it only
            for the purpose for which it was disclose and not disclose the
            information to third parties for their own use.
          </li>
          <br />
          <li>
            In some cases, your personal information may be stored or processed
            outside of Canada and may therefore be subject to the laws of those
            countries.
          </li>
        </ul>
      </div>

      <h3 class="font--h2 privacy__heading">Policy 3 – Consent:</h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            We will obtain an individual’s consent to collect, use or disclose
            personal information (except where, as noted below, we are
            authorized to do so without consent).
          </li>
          <br />
          <li>
            Consent may be provided in writing or electronically and may be
            collected by an authorized representative of Alberta Golf. In some
            cases, consent may be implied where the purpose for collecting using
            or disclosing the personal information would be considered obvious
            and the individual voluntarily provides personal information for
            that purpose.
          </li>
          <br />
          <li>
            Consent may also be implied where an individual is given notice and
            a reasonable opportunity to opt-out of his or her personal
            information being used for mail-outs, the marketing of new services
            or products, fundraising and the individual does not opt-out.
          </li>
          <br />
          <li>
            Subject to certain exceptions (e.g., the personal information is
            necessary to provide the service or product, or the withdrawal of
            consent would frustrate the performance of a legal obligation),
            individuals can withhold or withdraw their consent for Alberta Golf
            to use their personal information in certain ways. An individual’s
            decision to withhold or withdraw their consent to certain uses of
            personal information may restrict our ability to provide a
            particular service or product. If so, we will explain the situation
            to assist the individual in making the decision.
          </li>
          <br />
          <li>
            We may collect, use or disclose personal information without the
            individual’s knowledge or consent in the following limited
            circumstances:
          </li>
        </ul>
        <ul class="privacy__indent-list">
          <br />
          <li>
            When the collection, use or disclosure of personal information is
            permitted or required by law;
          </li>
          <li>
            In an emergency that threatens an individual's life, health, or
            personal security;
          </li>
          <li>
            When the personal information is considered at law to be publicly
            available (e.g., where published in a telephone directory);
          </li>
          <li>When we require legal advice from a lawyer;</li>
          <li>For the purposes of collecting a debt;</li>
          <li>To protect ourselves from fraud;</li>
          <li>
            To investigate an actual or anticipated breach of an agreement or a
            contravention of the law.
          </li>
        </ul>
      </div>

      <h3 class="font--h2 privacy__heading">
        Policy 4 – Retaining Personal Information:
      </h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            If we use personal information to make a decision that directly
            affects the member or customer, we will retain that personal
            information for at least one year so that the individual has a
            reasonable opportunity to request access to it otherwise we will
            retain personal information only as long as necessary to fulfill the
            identified purposes or a legal or business purpose.
          </li>
        </ul>
      </div>

      <h3 class="font--h2 privacy__heading">
        Policy 5 – Ensuring Accuracy of Personal Information:
      </h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            We will make reasonable efforts to ensure that personal information
            is accurate and complete where it may be used to make a decision
            about the individual or disclosed to another organization.
          </li>
          <li>
            Individuals may request correction to their personal information in
            order to ensure its accuracy and completeness. A request to correct
            personal information must be made in writing to our Privacy Officer,
            at the address provided below, and provide sufficient detail to
            identify the personal information and the correction being sought.
          </li>
          <li>
            If the personal information is demonstrated to be inaccurate or
            incomplete, we will correct the information as required and send the
            corrected information to any organization to which we disclosed the
            personal information in the previous year. If the correction is not
            made, we will note the individual’s correction request in the file.
          </li>
        </ul>
      </div>

      <h3 class="font--h2 privacy__heading">
        Policy 6 – Storing and Securing Personal Information:
      </h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            We are committed to ensuring the security of personal information in
            order to protect it from unauthorized access, collection, use,
            disclosure, copying, modification or disposal or similar risks.
          </li>
          <br />
          <li>
            We will protect personal information using a range of measures,
            consistent with industry practices for the protection of similar
            information. These safeguards will include the following methods of
            protection:
          </li>
          <br />
        </ul>
        <ul class="privacy__indent-list">
          <li>
            Physical measures, such as locked filing cabinets and restricted
            access to offices and facilities;
          </li>
          <li>
            Organizational measures, such as employee security clearances and
            restricted, “need-to- know” access;
          </li>
          <li>
            Technological measures, such as the use of passwords, encryption and
            intrusion detection software.
          </li>
        </ul>
        <ul class="privacy__no-disc">
          <br />
          <li>
            Any service providers performing services on our behalf must provide
            the same level of security safeguards as Alberta Golf itself
            provides.
          </li>
          <br />
          <li>
            We will use appropriate security measures when destroying member’s
            and customer’s personal information such as shredding of paper
            documents and deletion or anonymization of electronically stored
            information.
          </li>
          <br />
          <li>
            We will continually review and update our security policies and
            controls as technology changes to ensure ongoing personal
            information security.
          </li>
        </ul>
      </div>

      <h3 class="font--h2 privacy__heading">
        Policy 7 – Providing Individuals Access to Personal Information:
      </h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            Individuals have a right to access their personal information,
            subject to limited exceptions provided by law, such as information
            that contains references to other individuals, information that
            cannot be disclosed for legal, security or commercial reasons, or
            information that is subject to solicitor-client privilege.
          </li>
          <li>
            A request to access personal information must be made in writing to
            the Privacy Officer, at the address noted below, and must provide
            sufficient detail to identify the personal information being sought.
          </li>
          <li>
            Upon request, we will also tell members and customers how we use
            their personal information and to whom it has been disclosed if
            applicable.
          </li>
          <li>
            We will make the requested information available within 30 business
            days, or provide written notice of an extension where additional
            time is required to fulfill the request.
          </li>
          <li>
            A minimal fee may be charged for providing access to personal
            information. Where a fee may apply, we will inform the member and
            customer of the cost and request further direction from the member
            and customer on whether or not we should proceed with the request.
          </li>
          <li>
            If a request is refused in full or in part, we will notify the
            member or customer in writing, providing the reasons for refusal and
            the recourse available to the member or customer.
          </li>
        </ul>
      </div>

      <h3 class="font--h2 privacy__heading">
        Policy 8 – Questions and Complaints: The Role of the Privacy Officer:
      </h3>
      <div>
        <ul class="privacy__no-disc">
          <li>
            The Privacy Officer is responsible for ensuring Alberta Golf’s
            compliance with this policy and all applicable privacy laws.
          </li>
          <br />
          <li>
            We apply our best efforts to protect our members’, volunteers’ and
            customers’ privacy. If our members, volunteers and customers have
            any concerns, they are free to contact our Privacy Officer. We hope
            that the Officer will be able to resolve any problems.
          </li>
          <br />
          <li>
            If concerns are not resolved, individuals should direct any
            complaints, concerns or questions regarding Alberta Golf’s
            compliance in writing to the Privacy Officer:
          </li>
          <div class="privacy__no-disc">
            <br />
            <li>Alberta Golf Privacy Officer</li>
            <li>22 – 11410 27 Street SE</li>
            <li>Calgary, AB T2Z 3R6</li>
            <li>
              E-mail:
              <a href="mailto:info@albertagolf.org">info@albertagolf.org</a>
              Subject Heading: “Privacy Officer”
            </li>
          </div>
        </ul>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useHead } from '@vueuse/head'
import { playerTitle } from '@player/_lib/playerTitle'

export default defineComponent({
  name: 'Privacy',
  setup() {
    useHead({
      title: playerTitle('Privacy Policy')
    })
  }
})
</script>

<style lang="scss" scoped>
ol,
ul {
  list-style: disc;
}
.privacy {
  padding-bottom: var(--spacing-s3);

  &__heading {
    padding-top: var(--spacing-s4);
    padding-bottom: var(--spacing-s6);
  }

  &__subheading {
    font-weight: 600;
    font-size: 20px;
    font-style: normal;
    padding-top: var(--spacing-s4);
    padding-bottom: var(--spacing-s6);
  }

  &__content {
    padding-top: var(--spacing-s6);
  }

  &__indent-list {
    margin-left: var(--grid--gutter-width);

    &--sm {
      margin-left: calc(var(--grid--gutter-width) / 2);
    }
  }

  &__no-disc {
    list-style: none;
  }
}
</style>
